/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const { windowLoaded } = require('@grpn/document-states');

const PageTracking = require('../../../modules/page/frontend/helpers/tracking');

const gtmHelper = require('./helpers/gtm');

module.exports = {
  initialize(config) {
    this.config = config;
    return this._addListeners();
  },

  onReady() {
    document.body.classList.remove('no-js');
    return document.body.classList.add('pull-app-is-ready');
  },

  onLoad() {
    new PageTracking().pageReady();
    gtmHelper.manageUpdateGtmDataTopFiveDeals();
    return document.body.classList.add('pull-app-is-loaded');
  },

  _addListeners() {
    function domReady(callback) {
      if (
        document.readyState === 'complete' ||
        document.readyState === 'interactive'
      ) {
        callback();
        return;
      } else {
        document.addEventListener('DOMContentLoaded', callback);
        return;
      }
    }

    domReady(this.onReady.bind(this));
    windowLoaded.then(this.onLoad);
  },
};
